import * as SC from './style';

interface ISplitBox {
  headline: string;
  content: string;
}

const SplitBox = ({ headline, content }: ISplitBox) => {
  return (
    <SC.SplitBox>
      <hr />
      <h2>{headline}</h2>
      <p>{content}</p>
    </SC.SplitBox>
  );
};

export default SplitBox;
